import { render, staticRenderFns } from "./CardHead.vue?vue&type=template&id=04b96dcf&scoped=true"
import script from "./CardHead.vue?vue&type=script&lang=js"
export * from "./CardHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b96dcf",
  null
  
)

export default component.exports